import { isSameDay } from '@internationalized/date';
import { DateValue } from 'react-aria';

const isSameDate = (date1: DateValue, date2: DateValue): boolean => {
    return isSameDay(date1, date2);
};

export default isSameDate;
